import angular from 'angular';
import { BehaviorSubject } from 'rxjs';
import '../core.module';

export const THEMES = ['light', 'dark'];

class ThemeService {
  constructor(StorageService, STORAGE_KEYS, $injector, API_BASE_URL) {
    this.StorageService = StorageService;
    this.STORAGE_KEYS = STORAGE_KEYS;
    this.$injector = $injector;
    this.API_BASE_URL = API_BASE_URL;
    const stored = this.StorageService.get(STORAGE_KEYS.THEME) || 'light';
    this.theme$ = new BehaviorSubject(stored);
    this.applyTheme(stored);
  }

  get current() {
    return this.theme$.value;
  }

  toggle() {
    this.setTheme(this.current === 'dark' ? 'light' : 'dark');
  }

  setTheme(theme, { persist = true } = {}) {
    this.applyTheme(theme);
    this.StorageService.set(this.STORAGE_KEYS.THEME, theme);
    this.theme$.next(theme);
    if (persist) this.saveToProfile(theme);
  }

  applySaved(theme) {
    if (!THEMES.includes(theme) || theme === this.current) return;
    this.setTheme(theme, { persist: false });
  }

  saveToProfile(theme) {
    const session = this.$injector.get('SessionService');
    if (!session.isAuthenticated()) return null;
    return this.$injector
      .get('$http')
      .patch(`${this.API_BASE_URL}/users/me/preferences`, { theme }, { silentErrors: true })
      .catch(() => null);
  }

  applyTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
  }
}

ThemeService.$inject = ['StorageService', 'STORAGE_KEYS', '$injector', 'API_BASE_URL'];

angular
  .module('app.core')
  .service('ThemeService', ThemeService)
  .run(['ThemeService', () => null]);

export default ThemeService;
